var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('input',_vm._b({staticClass:"custom-field",attrs:{"disabled":_vm.disabledInput,"type":_vm.typeInput,"readonly":_vm.readonlyInput},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }